// extracted by mini-css-extract-plugin
export default {"support":"Support_support__ayRB8"};